export default function TrustSection() {
  return (
    <section className="py-12 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-shield-check-line mr-2"></i>
            Partenaire de Confiance
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ils Nous Font Confiance
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Plus de 150 syndics, agences immobilières et AIS nous confient la maintenance de leurs biens
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Left - Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]">
            <img
              src="https://public.readdy.ai/ai/img_res/caf8ceb50246f0a5aa931c1a9b8e4b7d.jpg"
              alt="Partenariat professionnel"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <p className="text-white text-lg font-semibold">
                Des partenariats durables basés sur la confiance et l'expertise
              </p>
            </div>
          </div>

          {/* Right - Stats */}
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                <i className="ri-building-line text-2xl text-teal-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">150+</div>
              <div className="text-gray-600 text-sm">Syndics & Agences Partenaires</div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg mb-4">
                <i className="ri-tools-line text-2xl text-orange-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">5000+</div>
              <div className="text-gray-600 text-sm">Interventions Réussies</div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-4">
                <i className="ri-time-line text-2xl text-blue-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">&lt;48h</div>
              <div className="text-gray-600 text-sm">Délai d'Intervention</div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mb-4">
                <i className="ri-star-line text-2xl text-green-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">4.9/5</div>
              <div className="text-gray-600 text-sm">Satisfaction Client</div>
            </div>
          </div>
        </div>

        {/* Insurance Badge */}
        <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-6">
              <div className="bg-white p-4 rounded-xl shadow-md border border-gray-200">
                <img
                  src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/e5d57b0a88355b09a1fa98dd409d1ef8.png"
                  alt="Assurance Fédérale"
                  className="h-12 w-auto"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Assurance Responsabilité Civile Professionnelle
                </h3>
                <p className="text-gray-600">
                  Couverture complète pour tous nos chantiers - Assurance Fédérale
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 bg-teal-50 px-6 py-3 rounded-full whitespace-nowrap">
              <i className="ri-shield-check-fill text-2xl text-teal-600"></i>
              <span className="font-semibold text-teal-700">Assuré & Certifié</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
